import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Styles from "./index.module.scss";
import clsx from "clsx";
import useMDProfile, {
  ONE_MILLION_UNIT,
} from "../../../Hooks/useClientProfile";
import { ClientHistoryModalTable } from "../ClientHistoryModalTable";
import { useEffect, useMemo, useRef, useState } from "react";
import { formatNumber } from "../../../Utils";

import napKnbImg from "../../../Css/img/huong_dan_nap_KNB.jpg";
import { RiMessengerLine } from "react-icons/ri";
import { Path } from "../../../Api/Path";

// Component: QR Code Section
const QRCodeSection = ({
  loading,
  error,
  qrCode,
  voucherText,
  qrUserId,
  handleSubmit,
  handleGenerateDefaultQR,
  voucher,
  example,
  handleAmountChange,
  amount,
  showNewVersion,
  handleChangeVersion,
  handleNormalAmountChange,
  qrNormalAmount,
  qrNormal,
  handleGenerateNormalQR,
  qrNormalError,
}) => {
  // Hàm định dạng đơn vị
  const formatUnit = (value, isShowCurrency = true, showUnit = true) => {
    let formattedValue;

    if (value / 1000 > 999) {
      formattedValue = formatNumber(value / 1000000);
      return showUnit
        ? `${formattedValue}${isShowCurrency ? "tr" : " tr"}`
        : formattedValue;
    } else {
      formattedValue = formatNumber(value / 1000);
      return showUnit ? `${formattedValue}k` : formattedValue;
    }
  };

  // Tạo chi tiết voucher với useMemo để tối ưu hiệu suất
  const voucherDetails = useMemo(() => {
    if (!example || !voucher) return null;

    const minPay = formatUnit(voucher.minPay * ONE_MILLION_UNIT, false);
    const minPayWithoutUnit = formatUnit(
      voucher.minPay * ONE_MILLION_UNIT,
      false,
      false
    );
    const limit1 = formatUnit(voucher.limit1 * ONE_MILLION_UNIT, false);
    const limit2 = formatUnit(voucher.limit2 * ONE_MILLION_UNIT, false);
    const firstKnbKhoa = example.first.knbKhoa;
    const firstMoney = formatUnit(example.first.money);
    const secondKnbKhoa = example.second.knbKhoa;
    const secondMoney = formatUnit(example.second.money);
    const refKnbKhoa = example.refKnbKhoa;

    return (
      <>
        <p>
          {`Tích lũy ${minPayWithoutUnit} đến ${limit1} đầu: ${firstKnbKhoa} KNB khuyến mãi/${firstMoney}`}
        </p>
        {example.second.money > 0 ? (
          <p>
            {`Tích lũy ${minPayWithoutUnit} đến ${limit2} tiếp theo: ${secondKnbKhoa} KNB khuyến mãi/${secondMoney}`}
          </p>
        ) : (
          <p>Từ 0 - 100k tiếp theo: 1KNB/100k</p>
        )}
        {refKnbKhoa > 0 && (
          <p>{`Thêm 100k - ID ${qrUserId} được tặng ${refKnbKhoa} KNB khuyến mãi`}</p>
        )}
        <p>{`Tối thiểu một lần thêm khuyến mãi: ${minPay}`}</p>
      </>
    );
  }, [example, voucher, qrUserId]);

  // Tách thành các component nhỏ hơn để dễ quản lý
  const renderLoadingState = () => (
    <div className={clsx(Styles.loading)}>
      <p>Đang xác minh . . .</p>
    </div>
  );

  const renderErrorState = () => (
    <div className={clsx(Styles.error)}>
      <p>Vui lòng kiểm tra lại ID hoặc để trống để tạo QR mặc định</p>
      <p>
        Bấm để
        <strong onClick={handleGenerateDefaultQR}>Tạo QR mặc định</strong>
      </p>
    </div>
  );

  const renderQRContent = () => (
    <>
      <p className={clsx(Styles.title)}>Thêm KNB KHUYẾN MÃI - NHẬN KNB khuyến mãi</p>
      <img src={qrCode} alt="QR Code" />
      <div className={clsx(Styles.qrTextBlock)}>
        <p className={clsx(Styles.qrInfor)}>
          QR với ID: {qrUserId} - Nhận KNB khuyến mãi
        </p>
        <div className={clsx(Styles.qrDetailCard)}>
          {voucherText && <p className={clsx(Styles.qrDetail)}>{voucherText}</p>}
          <p className={clsx(Styles.qrDetail)}>
            1 KNB khuyến mãi = 20 tiền đồng khuyến mãi
          </p>
          <p className={clsx(Styles.qrDetail)}>
            Trạng thái KNB/tiền đồng là khoá
          </p>
          <p className={clsx(Styles.qrDetail)}>
            Chỉ sử dụng được với chức năng xoay đồ xanh tại NPC thương nhân tây vực
          </p>
        </div>
        {voucher && (
          <div className={clsx(Styles.voucherDetail)}>
            {voucherDetails}
          </div>
        )}
      </div>
    </>
  );

  const renderInputForm = () => (
    <div
      className={clsx(Styles.inputVoucher)}
      style={{ margin: "20px auto 10px auto" }}
    >
      {!showNewVersion ? null : (
        <>
          <p style={{ textAlign: "left" }}>Bạn cần tạo QR với số tiền ?</p>
          <div className={clsx(Styles.inputRow, Styles.amountRow)}>
            <input
              id="amount"
              name="amount"
              type="text"
              placeholder="Nhập số tiền"
              value={amount.formatValue}
              onChange={handleAmountChange}
              className={clsx(Styles.amountInput)}
            />
            <button type="button" onClick={handleSubmit}>
              Tạo QR khuyến mãi
            </button>
          </div>
        </>
      )}

      {error && <span className={clsx(Styles.errorMessage)}>{error}</span>}
    </div>
  );

  const renderNormalQRSection = () => (
    <div className={clsx(Styles.qrCodeNormal)}>
      {loading && renderLoadingState()}
      {!loading && error && renderErrorState()}
      {!error && !loading && qrNormal && (
        <>
          <p className={clsx(Styles.title)}>Thêm KIM NGUYÊN BẢO - NHẬN KNB</p>
          <img src={qrNormal} alt="QR Code" className={clsx(Styles.qrCodeImg)} />
          <div className={clsx(Styles.qrTextBlock)}>
            <p className={clsx(Styles.qrInfor)}>
              QR với ID: {qrUserId} - Nhận KNB
            </p>
            <div className={clsx(Styles.qrDetailCard)}>
              <p className={clsx(Styles.qrDetail)}>
                Tỉ lệ: 100k nhận 1 KNB, tối thiểu 1 lần thêm là 100k
              </p>
              <p className={clsx(Styles.qrDetail)}>1 KNB = 20 tiền đồng (xu)</p>
              <p className={clsx(Styles.qrDetail)}>
                Hoặc 1 KNB = 60 Tiền đồng hoạt động, để trải nghiệm nhanh máy chủ,
                hạn sử dụng 2 tháng
              </p>
            </div>
          </div>
        </>
      )}

      <div
        className={clsx(Styles.inputVoucher)}
        style={{ margin: "20px auto 10px auto" }}
      >
        {showNewVersion && !error && (
          <>
            <p>Bạn cần tạo QR với số tiền ?</p>
            <div className={clsx(Styles.inputRow, Styles.amountRow)}>
              <input
                id="amount"
                name="amount"
                type="text"
                placeholder="Nhập số tiền"
                value={qrNormalAmount.formatValue}
                onChange={(e) => handleNormalAmountChange(e)}
                className={clsx(Styles.amountInput)}
              />
              <button type="button" onClick={handleGenerateNormalQR}>
                Tạo QR
              </button>
            </div>
          </>
        )}

        {error && <span className={clsx(Styles.errorMessage)}>{error}</span>}
        {!error && qrNormalError && (
          <span className={clsx(Styles.errorMessage)}>{qrNormalError}</span>
        )}
      </div>
    </div>
  );

  const renderFooter = () => (
    <div className={clsx(Styles.qrFooter)}>
      <div className={clsx(Styles.footerContent)}>
        <Button
          type="button"
          className={clsx(Styles.toggleButton)}
          onClick={() => handleChangeVersion(!showNewVersion)}
        >
          {showNewVersion ? "Tạo QR linh hoạt" : "Tạo QR với số tiền nhập"}
        </Button>
        <div className={clsx(Styles.messages)}>
          <p className={clsx(Styles.helpText)}>
            Đăng nhập lại và nhận KNB tại tiền trang Ba Lăng
            Huyện
          </p>
          <p className={clsx(Styles.note)}>
            Không đổi nội dung sau khi quét mã
          </p>
        </div>
        <button
          className={clsx(Styles.contactButton)}
          onClick={() => window.open(Path.SUPPORT, "_blank")}
        >
          <div className={clsx(Styles.buttonContent)}>
            <RiMessengerLine size={20} />
            <span>Liên hệ</span>
          </div>
        </button>
      </div>
    </div>
  );

  return (
    <div className={clsx(Styles.payment)}>
      <div className={clsx(Styles.qrHeader)}>
        <h2 className={clsx(Styles.title)}>
          Thêm Kim Nguyên Bảo tự động
        </h2>
      </div>

      <div className={clsx(Styles.qrCode)}>
        {/* Phần QR khuyến mãi */}
        <div className={clsx(Styles.qrCodeKm)}>
          {loading && renderLoadingState()}
          {!loading && error && renderErrorState()}
          {!error && !loading && qrCode && renderQRContent()}

          {renderInputForm()}

            <div className={clsx(Styles.noteContainer)}>
             <p className={clsx(Styles.note)}>
               Số KNB sau khi được tính theo tỉ lệ khuyến mãi sẽ được làm tròn xuống số nguyên gần nhất nếu lẻ thập phân.
             </p>
            <p className={clsx(Styles.note)}>
              Tích luỹ tính theo id đăng nhập và tính lại từ đầu mỗi khi đủ tổng
              2 mức tích luỹ trên
            </p>
          </div>
        </div>

        {/* Phần QR thêm thường */}
        {renderNormalQRSection()}
      </div>

      {/* Phần footer */}
      {renderFooter()}
    </div>
  );
};
// Component: User Information Section
const UserInfoSection = ({
  user,
  copiedText,
  handleCopy,
  input,
  handleInput,
  handleSubmit,
}) => {
  return (
    <div className={clsx(Styles.informationDetail)}>
      <div className={clsx(Styles.userInfoLeft)}>
        <div className={clsx(Styles.account)}>
          <p>Tài khoản: {user.Name}</p>
        </div>

        <div className={clsx(Styles.knbDetail)}>
          <p className={clsx(Styles.knb)}>
            KNB: <strong>{user.Knb}</strong>
          </p>
          <p className={clsx(Styles.knbKhoa)}>
            KNB KM: <strong>{user.KnbKhoa}</strong>
          </p>
        </div>
      </div>

      <div className={clsx(Styles.userInfoRight)}>
        <label htmlFor="qrUserId" className={clsx(Styles.qrUserIdLabel)}>
          Tạo QR cho ID tài khoản bên dưới
        </label>
        <div className={clsx(Styles.inputBlock)}>
          <input
            id="qrUserId"
            name="qrUserId"
            value={input}
            onChange={handleInput}
            placeholder="Nhập ID cần tạo mã"
          />
          <button type="button" onClick={handleSubmit}>
            Tạo QR cho ID tài khoản
          </button>
        </div>
        <p className={clsx(Styles.qrUserIdNote)}>
          Để trống rồi bấm tạo QR để dùng ID đăng nhập hiện tại.
        </p>
      </div>

      {/* <div className={clsx(Styles.reference)}>
        <p>Mã giới thiệu thưởng 5% Khuyến mãi Khóa trên tổng thêm</p>
        <div>
          <button
            type="button"
            className={clsx(Styles.copyButton)}
            onClick={() => handleCopy(true)}
            style={{
              backgroundColor: "#a04747",
            }}
          >
            <IoCopyOutline size={16} />
            {copiedText && copiedText === user.Name
              ? " Đã sao chép!"
              : "Sao chép mã giới thiệu"}
          </button>

          <button
            type="button"
            className={clsx(Styles.copyButton)}
            onClick={() => handleCopy(false)}
            style={{
              backgroundColor: "#a04747",
            }}
          >
            <LuClipboardCopy size={16} />
            {copiedText && copiedText !== user.Name
              ? " Đã sao chép!"
              : "Sao chép link giới thiệu"}
          </button>
        </div>
      </div> */}
    </div>
  );
};

// Component: History Section
const HistorySection = ({
  voucherHistories,
  introducedHistories,
  totalBonus,
  columns,
}) => {
  return (
    <div className={clsx(Styles.informationExtra)}>
      {voucherHistories && voucherHistories.length > 0 && (
        <ClientHistoryModalTable
          title={"Lịch sử thêm:"}
          columns={columns.voucher}
          data={voucherHistories}
        />
      )}
      {introducedHistories && introducedHistories.length > 0 && (
        <ClientHistoryModalTable
          title={"Lịch sử giới thiệu:"}
          total={totalBonus}
          columns={columns.introduced}
          data={introducedHistories}
        />
      )}
    </div>
  );
};

// Component: Modal Footer
const ModalFooter = ({ user, handleUpdate, handleChangePass, handleClose }) => {
  return (
    <Modal.Footer className={clsx(Styles.footer)}>
      <div className={clsx(Styles.information)}>
        {user && (
          <div className={clsx(Styles.detail)}>
            <div className={clsx(Styles.itemWrap)}>
              {user.Email && <p>Email: {user.Email}</p>}
            </div>
            <div className={clsx(Styles.itemWrap)}>
              {user.Phone && <p>Số điện thoại: {user.Phone}</p>}
            </div>
          </div>
        )}
      </div>
    </Modal.Footer>
  );
};

// Main Component: MDProfile
function ClientProfile({
  showProfile,
  handleClose,
  data,
  histories,
  introduceId,
}) {
  const {
    loading,
    voucherText,
    user,
    qrCode,
    handleChangePass,
    handleUpdate,
    handleSubmit,
    voucherHistories,
    introducedHistories,
    error,
    handleGenerateDefaultQR,
    input,
    qrUserId,
    handleInput,
    voucherHistoryColumns,
    introducedHistoryColumns,
    copiedText,
    handleCopy,
    voucher,
    totalBonus,
    example,
    handleAmountChange,
    amount,
    showNewVersion,
    handleChangeVersion,
    handleNormalAmountChange,
    qrNormalAmount,
    qrNormal,
    handleGenerateNormalQR,
    qrNormalError,
  } = useMDProfile({ data, histories, introduceId });

  const [modalZIndex, setModalZIndex] = useState(2000);
  const refModal = useRef(null);
  const rafRef = useRef(null);
  const lastValueRef = useRef(2000);

  useEffect(() => {
    if (!showProfile || !refModal.current || !refModal.current.dialog) return;

    const dialogElement = refModal.current.dialog;

    const handleScroll = () => {
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }

      rafRef.current = requestAnimationFrame(() => {
        const scrollPosition = dialogElement.scrollTop;
        const newZIndex = scrollPosition > 40 ? 200000 : 2000;

        // Only update if value changed
        if (newZIndex !== lastValueRef.current) {
          setModalZIndex(newZIndex);
          lastValueRef.current = newZIndex;
        }
      });
    };

    dialogElement.addEventListener("scroll", handleScroll);

    return () => {
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }
      dialogElement.removeEventListener("scroll", handleScroll);
    };
  }, [showProfile]);

  return (
    <Modal
      style={{ backgroundColor: "none", zIndex: modalZIndex }}
      contentClassName={clsx(Styles.main)}
      show={showProfile}
      size="xl"
      centered
      backdrop={false}
      ref={refModal}
    >
      <Modal.Body className={clsx(Styles.bodyWrap)}>
        <div className={clsx(Styles.flexGrow)}>
          <div className={clsx(Styles.container)}>
            <QRCodeSection
              loading={loading}
              error={error}
              qrCode={qrCode}
              voucherText={voucherText}
              qrUserId={qrUserId}
              handleSubmit={handleSubmit}
              handleGenerateDefaultQR={handleGenerateDefaultQR}
              voucher={voucher}
              example={example}
              handleAmountChange={handleAmountChange}
              amount={amount}
              showNewVersion={showNewVersion}
              handleChangeVersion={handleChangeVersion}
              qrNormalAmount={qrNormalAmount}
              handleNormalAmountChange={handleNormalAmountChange}
              qrNormal={qrNormal}
              handleGenerateNormalQR={handleGenerateNormalQR}
              qrNormalError={qrNormalError}
            />
            <div className={clsx(Styles.information)}>
              <UserInfoSection
                user={user}
                copiedText={copiedText}
                handleCopy={handleCopy}
                input={input}
                handleInput={handleInput}
                handleSubmit={handleSubmit}
              />
              {/* <HistorySection
                voucherHistories={voucherHistories}
                introducedHistories={introducedHistories}
                totalBonus={totalBonus}
                columns={{
                  voucher: voucherHistoryColumns,
                  introduced: introducedHistoryColumns,
                }}
              /> */}
            </div>
          </div>
        </div>
      </Modal.Body>
      <ModalFooter
        user={user}
        handleUpdate={handleUpdate}
        handleChangePass={handleChangePass}
        handleClose={handleClose}
      />
    </Modal>
  );
}

export default ClientProfile;
